import Service from './Service';
import Server from './server';
import BroadcastChannel from './BroadcastChannel';
export const CHECKING_ACCOUNT_STATUS = 'checkingAccountStatus';
export const LOGGED_OUT_USER_ID = 'loggedout';
export const LOGGED_OUT = 'loggedOut';
export const LOGGED_IN = 'loggedIn';

export const LOGIN_POPUP = 'loginPopup';
export const REGISTER_POPUP = 'registerPopup';
export const RESET_PASSWORD_POPUP = 'resetPasswordPopup';
export const GET_APP_POPUP = 'getAppPopup';
export const ACCOUNT_DELETED_POPUP = 'accountDeletedPopup';

try {
  const urlObject = new URL(window.location.href);
  const searchParams = urlObject.searchParams;
  const referrer = searchParams.get('referrer');
  if (referrer) localStorage.setItem('logictry.referrer', referrer);
} catch {
  //
}

class UserAccount extends Service {
  get isDevAccount() {
    return this.account && this.account.featureFlags && this.account.featureFlags.dev;
  }
  get showBetaFeatures() {
    return this.account && this.account.featureFlags && this.account.featureFlags.beta;
  }
  get isCheckingAccountStatus() {
    return this.state === CHECKING_ACCOUNT_STATUS;
  }
  get isLoggedIn() {
    return !!(this.state === LOGGED_IN && this.account);
  }
  get isLoggedOut() {
    return this.state === LOGGED_OUT;
  }
  get exists() {
    if (!this.account || !this.account._id || this.account._id === LOGGED_OUT_USER_ID) return false;
    return true;
  }
  get existsWithPasswordButNotLoggedIn() {
    if (this.account && this.account.password) return true;
    return false;
  }

  state = CHECKING_ACCOUNT_STATUS;
  account = { _id: LOGGED_OUT_USER_ID };

  getAccountStatus() {
    Server.checkAuth(true).then((a) => {
      if (a._id && a.loggedIn) return this.getUserProfile(a);
      this.state = LOGGED_OUT;
      this.clearAccount();
      return this.emitStateUpdate();
    }).catch(() => {
      this.state = LOGGED_OUT;
      this.clearAccount();
      return this.emitStateUpdate();
    });
  }

  clearAccount() {
    this.account = { _id: LOGGED_OUT_USER_ID };
  }
  showLoginPopup() {
    this.showPopup = LOGIN_POPUP;
    this.emitStateUpdate();
  }
  showRegisterPopup() {
    this.showPopup = REGISTER_POPUP;
    this.emitStateUpdate();
  }
  showResetPasswordPopup() {
    this.showPopup = RESET_PASSWORD_POPUP;
    this.emitStateUpdate();
  }
  showGetAppPopup() {
    this.showPopup = GET_APP_POPUP;
    this.emitStateUpdate();
  }
  showAccountDeletedPopup() {
    this.showPopup = ACCOUNT_DELETED_POPUP;
    this.emitStateUpdate();
  }
  clearPopup() {
    if (!this.showPopup) return;
    this.showPopup = null;
    this.emitStateUpdate();
  }

  async registerAccount(account) {
    try {
      const referrer = localStorage.getItem('logictry.referrer');
      if (referrer) account.referrer = referrer;
    } catch {
      //
    }
    const registeredAccount = await Server.registerAccount(account);
    if (registeredAccount?.error === 'UserPermanentlyDeleted') {
      this.account.email = account.email;
      this.account.error = registeredAccount.error;
      this.showAccountDeletedPopup();
    }
    return registeredAccount;
  }
  async updatePassword(email, password) {
    const results = await Server.updatePassword(password);
    if (results && results._id) this.onPasswordChanged();
    return this.loginAccount({ email, password });
  }
  async resetPassword(e) {
    return Server.resetPassword(e);
  }
  async loginAccount(body) {
    if (this.state !== LOGGED_OUT) return null;

    const a = await Server.loginAccount(body);
    if (a) this.account = a;
    if (a?.error === 'UserPermanentlyDeleted') this.showAccountDeletedPopup();
    if (a && a._id) {
      this.getUserProfile(a);
      return null;
    }

    this.state = LOGGED_OUT;
    this.emitStateUpdate();
    return null;
  }
  async updateUserProfile(p) {
    const account = await Server.updateProfile(p);
    if (account && account.error) this.updateState = account;
    else this.updateState = { success: true };
    if (account && account._id) this.account = { ...this.account, ...account };
    return this.emitStateUpdate();
  }
  async getUserProfile(_account) {
    this.clearPopup();

    // Artificially sleep for 100ms if _account already exists to allow logging_in state to persist
    if (_account) await new Promise(resolve => setTimeout(resolve, 100));

    // Get Account unless already have it
    const account = _account || await Server.getProfile();
    if (account.error === 'UserNotAuthorized') {
      this.state = LOGGED_OUT;
      this.clearAccount();
      return this.emitStateUpdate();
    }
    try {
      localStorage.removeItem('logictry.referrer');
    } catch {
      //
    }
    if (account && account._id) {
      this.account = account;
      this.state = LOGGED_IN;
      BroadcastChannel.postMessage({ state: LOGGED_IN });
      return this.emitStateUpdate(this.state);
    }
    this.emitStateUpdate();
  }
  /** Pull-to-refresh / soft reload: refetch profile so emitStateUpdate(LOGGED_IN) clears app caches without a full document reload. */
  async refreshSessionFromServer() {
    if (!this.isLoggedIn) {
      this.getAccountStatus();
      return;
    }
    await this.getUserProfile();
  }
  async verifyCode(email, code) {
    return Server.verifyCode(email, code);
  }
  async logout() {
    if (!this.isLoggedIn) return;
    this.isLoggingOut = true;
    this.emitStateUpdate();
    await Server.logout();
    this.state = LOGGED_OUT;
    this.emitStateUpdate(this.state);
    BroadcastChannel.postMessage({ state: LOGGED_OUT });
    setTimeout(() => {
      window.location.reload();
    });
  }
  async changeUserImage(link) {
    if (!(this.account && this.account._id)) return new Error('Not Logged In');
    const newImage = { link };
    await Server.updateProfile({ image: newImage });
    this.account.image = newImage;
    return this.emitStateUpdate();
  }
  async addPhoneNumber(number) {
    const phone = { number };
    await Server.updateProfile({ phone });
    this.account.phone = phone;
    return this.emitStateUpdate();
  }
  formatUserImage(user) {
    if (user && user.image && user.image.link) return user.image.link;
    return null;
  }
  async setDeviceId(device) {
    const account = await Server.setDeviceId(device);
    if (account && account._id) this.account = { ...this.account, ...account };
    return this.emitStateUpdate();
  }

  claimsChanged(account) {
    const claim = (value) => JSON.stringify({
      email: value?.email || '',
      username: value?.username || '',
      fullname: value?.fullname || '',
      beta: !!value?.featureFlags?.beta,
      dev: !!value?.featureFlags?.dev,
      disableLiveActivity: !!value?.privacySettings?.disableLiveActivity,
    });
    return claim(this.account) !== claim(account);
  }
}

const singleton = new UserAccount();
Server.onLoggedOutStatusCode = () => {
  singleton.logout();
};
export default singleton;
